export function getLocation() {
  return window.location.pathname;
}

export function scrollToId(id) {
  const section = document.querySelector(`#${id}`);
  section.scrollIntoView({ behavior: "smooth", block: "start" });
}
